import { ImportMetaEnv } from './ImportMetaEnv';

export const prod: ImportMetaEnv = {
  NODE_ENV: 'production',
  // BASE_API: 'http://10.134.105.94:30200/api',
  BASE_API: '/shop',
};
